<svg class="loading-spinner" viewBox="0 0 20 20.5" xmlns="http://www.w3.org/2000/svg">
  <path
    class="st0"
    d="M10 2.5c4.4 0 8 3.6 8 8s-3.6 8-8 8 -8-3.6-8-8S5.6 2.5 10 2.5M10 0.5c-5.5 0-10 4.5-10 10s4.5 10 10 10c5.5 0 10-4.5 10-10S15.5 0.5 10 0.5L10 0.5z"
  />
  <path
    class="st1"
    d="M10 3c2.1 0 3.9 0.8 5.3 2.2l2.1-2.1C15.5 1.2 12.9 0 10 0 7.1 0 4.5 1.2 2.6 3.1L4.7 5.2C6.1 3.8 7.9 3 10 3z"
  />
</svg>
